export var SidePanelLayoutBlockEnum;
(function (SidePanelLayoutBlockEnum) {
    SidePanelLayoutBlockEnum["PRICE"] = "PRICE";
})(SidePanelLayoutBlockEnum || (SidePanelLayoutBlockEnum = {}));
export var BlockVariantEnum;
(function (BlockVariantEnum) {
    BlockVariantEnum["A"] = "A";
    BlockVariantEnum["B"] = "B";
})(BlockVariantEnum || (BlockVariantEnum = {}));
export var ComponentEnum;
(function (ComponentEnum) {
    ComponentEnum["PRICE_BLOCK"] = "priceBlock";
    ComponentEnum["PRICE_EVOLUTION_CHART"] = "priceEvolutionChart";
    ComponentEnum["OFFERS_SALES_BLOCK"] = "offersSalesBlock";
    ComponentEnum["FSBO_BLOCK"] = "fsboBlock";
    ComponentEnum["NUTZUNGSDAUER_REDIRECT_BLOCK"] = "nutzungsdauerRedirectBlock";
    ComponentEnum["ESTIMA_LANDING_BLOCK"] = "estimaLandingBlock";
    ComponentEnum["PRICE_TABLE_BLOCK"] = "priceTableBlock";
    ComponentEnum["LINK_BOXES_BLOCK"] = "linkBoxesBlock";
    ComponentEnum["MFE_WLAC"] = "mfeWlac";
    ComponentEnum["FAQ_BLOCK"] = "faqBlock";
    ComponentEnum["PRICE_TABLE_BY_SUBTYPE_BLOCK"] = "priceTableBySubtypeBlock";
})(ComponentEnum || (ComponentEnum = {}));
